import React from "react";
import { Container } from "react-bootstrap";
import "../../incidentes.css";
import useVideoModal from "./useVideoModal";
import VideoModal from "./VideoModal";
import useProgresoVideos from "./useProgresoVideos";
import ProgresoResumen from "./ProgresoResumen";
import videoBaseURL from "./videoBaseURL";

const IA = () => {
  const { show, videoActivo, handleShow, handleClose } = useVideoModal();
  const { estaVisto, marcarVisto } = useProgresoVideos();

  // Datos de módulos y videos
  const modulos = [
    {
      titulo: "Módulo 1: Fundamentos (¿Qué es todo esto?)",
      videos: [
        {
          nombre: "Video 1.1: ¡Hola, IA! Más allá de las películas",
          url: `${videoBaseURL}Modulo_1_1.mp4`,
          //url: "/videos/Modulo_1_1.mp4",
          contenido: "¿Qué es la IA en términos sencillos? No es Skynet, es un software que toma decisiones o hace predicciones basadas en datos.",
          analogia: "Es como el GPS de tu coche. No sigue una ruta fija; recalcula basándose en el tráfico (datos en tiempo real) para tomar la mejor decisión (la ruta más rápida).",
          funcionPrincipal: "Automatizar tareas repetitivas y analizar cantidades masivas de datos que un humano no podría."
        },
        {
          nombre: "Video 1.2: El árbol de la IA (IA vs. ML vs. DL)",
          url: `${videoBaseURL}Modulo_1_2.mp4`,
          //url: "/videos/Modulo_1_2.mp4",
          contenido: "Aclaremos los términos.",
          analogia: "IA: concepto general, el árbol completo (ej. un chatbot). ML: rama principal que aprende de los datos sin ser programada explícitamente. DL: rama avanzada que usa redes neuronales para problemas complejos (ej. reconocimiento facial).",
          funcionPrincipal: "Comprender la jerarquía entre IA, ML y DL."
        }
      ]
    },
    {
      titulo: "Módulo 2: La Nueva Ola (Lo que ves en las noticias)",
      videos: [
        {
          nombre: "Video 2.1: IA Generativa (GenAI): La IA que crea",
          url: `${videoBaseURL}Modulo_2_1.mp4`,
          //url: "/videos/Modulo_2_1.mp4",
          contenido: "¿Qué es la GenAI? A diferencia del ML tradicional que clasifica o predice, la GenAI crea contenido nuevo.",
          analogia: "Piensa en el ML como un crítico de música que te dice si una canción será un éxito. La IA Generativa es el compositor que escribe una canción nueva.",
          funcionPrincipal: "ChatGPT (crea texto), DALL-E (crea imágenes), y generar scripts de automatización o resúmenes de incidentes."
        },
        {
          nombre: "Video 2.2: IA Agéntica (Agentic AI): La IA que hace.",
          url: `${videoBaseURL}Modulo_2_2.mp4`,
          //url: "/videos/Modulo_2_2.mp4",
          contenido: "Es el siguiente paso. No es solo un chatbot que responde, es un agente que actúa. Usa herramientas para completar tareas.",
          analogia: "Le pides a un chatbot (GenAI): ¿Cuál es el pronóstico del tiempo?. Te da una respuesta. Le pides a un Agente de IA: Si llueve mañana, reagenda mi reunión de las 10 a.m. y avísale a Juan. El agente entiende, revisa el clima",
          funcionPrincipal: "Automatización avanzada de tareas de soporte (lo veremos más adelante)."
        },
      ]
    },
    {
      titulo: "Módulo 3: Aplicación 1 - ITOps y Observabilidad (AIOps)",
      videos: [
        {
          nombre: "Video 3.1: El fin de la fatiga por alertas (AIOps).",
          url: `${videoBaseURL}Modulo_3_1.mp4`,
          //url: "/videos/Modulo_3_1.mp4",
          contenido: "El problema de ITOps: Miles de alertas, logs y métricas. ¿Cuál es importante? AIOps usa ML para analizar todo ese ruido.",
          analogia: "Eres un guardia de seguridad viendo 100 monitores. AIOps es un asistente que te dice: Ignora 99 monitores, solo mira el 74 y el 12. El tipo del monitor 74 es el mismo que robó en el 12 hace 5 minutos",
          funcionPrincipal: "Correlación de eventos, detección de anomalías (ej. el uso de CPU siempre baja a las 3 a.m., ¿por qué hoy no?) y análisis de causa raíz (RCA)."
        },
        {
          nombre: "Video 3.2: Observabilidad con Superpoderes (IA y Unknown Unknowns)..",
          url: `${videoBaseURL}Modulo_3_2.mp4`,
          //url: "/videos/Modulo_3_2.mp4",
          contenido: "La observabilidad (logs, métricas, trazas) te da los datos. La IA te da las respuestas.",
          analogia: "Tu coche hace un ruido raro. El mecánico (tú) revisa el motor, las llantas, etc. (observabilidad). La IA es el escáner de diagnóstico avanzado que escucha el ruido y te dice: El problema no es el motor, es el rodamiento trasero izquierdo y fallará en 80 km (predicción).",
          funcionPrincipal: "Encontrar problemas que no sabías que tenías (unknown unknowns) y mantenimiento predictivo."
        },
      ]
    },
    {
      titulo: "Módulo 4: Aplicación 2 - Redes y Ciberseguridad",
      videos: [
        {
          nombre: "Video 4.1: IA en la administración de redes (LAN/WAN).",
          url: `${videoBaseURL}Modulo_4_1.mp4`,
          //url: "/videos/Modulo_4_1.mp4",
          contenido: "Las redes modernas (SD-WAN, Wi-Fi 6) son demasiado complejas para gestionarlas manualmente.",
          analogia: "Gestionar una red sin IA es como dirigir el tráfico en una ciudad enorme con un solo semáforo. La IA es como Waze o Google Maps: redirige dinámicamente el tráfico de datos por la ruta óptima basándose en la congestión en tiempo real.",
          funcionPrincipal: "Optimización de tráfico, predicción de fallos en hardware (switches, routers) y autogestión de la red (self-healing networks)."
        },
        {
          nombre: "Video 4.2: Ciberseguridad - El gato y el ratón (IA vs. IA).",
          url: `${videoBaseURL}Modulo_4_2.mp4`,
          //url: "/videos/Modulo_4_2.mp4",
          contenido: "Los atacantes usan IA (para crear phishing avanzado). Los defensores necesitan IA.",
          analogia: "La seguridad tradicional es un guardia en la puerta pidiendo identificación (listas negras). La IA es un guardia que detecta comportamientos extraños (detección de anomalías): Juan (el contable) siempre accede a los servidores de 9 a 5. ¿Por qué intenta acceder a los servidores de desarrollo a las 3 a.m. desde Ucrania?.",
          funcionPrincipal: "Detección de amenazas en tiempo real (NDR), análisis de comportamiento (UEBA) y respuesta automatizada a incidentes (SOAR)."
        },
      ]
    },
    {
      titulo: "Módulo 5: Conclusión y El Futuro del Ingeniero",
      videos: [
        {
          nombre: 'Video 5.1: El "Agente" de soporte: Tu nuevo compañero de trabajo.',
          url: `${videoBaseURL}Modulo_5_1.mp4`,
          //url: "/videos/Modulo_5_1.mp4",
          contenido: "Uniendo todo. ¿Cómo se ve un día de trabajo con IA Agéntica?",
          escenarioRealista: [
            "AIOps detecta una latencia alta en la WAN (Video 3.1).",
            "El Agente de IA (Video 2.2) recibe la alerta.",
            "Actúa: ejecuta un traceroute (herramienta 1), revisa los logs del router (herramienta 2) y consulta la base de datos de rendimiento de la red (herramienta 3).",
            'Analiza: "La latencia es por congestión en el enlace del ISP-A".',
            "Actúa de nuevo: crea un ticket de soporte (herramienta 4) con toda la evidencia y te lo asigna.",
            "Opcional (GenAI): redacta un borrador de correo para el ISP notificando la falla (Video 2.1).",
          ],
          funcionPrincipal: "El Agente hizo en 30 segundos el trabajo de diagnóstico que a ti te tomaría 30 minutos.",
        },
        {
          nombre: "Video 5.2: ¿La IA me quitará el trabajo? (Tu rol en el futuro).",
          url: `${videoBaseURL}Modulo_5_2.mp4`,
          //url: "/videos/Modulo_5_2.mp4",
          contenido: "No. La IA es una herramienta, no un reemplazo.",
          analogia: "La calculadora no reemplazó a los matemáticos; les permitió dejar de sumar a mano y enfocarse en el cálculo. El IDE no reemplazó a los programadores; les permitió dejar de compilar a mano y enfocarse en la lógica.",
          funcionPrincipal: 'Dejarás de ser un "apaga-fuegos" (reactivo) para ser un "arquitecto" y "estratega" (proactivo). Tu trabajo será gestionar la IA, interpretar sus hallazgos complejos y diseñar sistemas más resilientes.',
        },
      ],
    },
  ];

  const todosLosVideos = modulos.flatMap((m) => m.videos);

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Inteligencia Artificial</h1>
        </div>

        <ProgresoResumen
          vistos={todosLosVideos.filter((v) => estaVisto(v.url)).length}
          total={todosLosVideos.length}
        />

        {modulos.map((modulo, idxModulo) => (
          <div key={modulo.titulo}>
            <div className="orgproc-subheading-wrap">
              <h2 className="orgproc-subheading">{modulo.titulo}</h2>
            </div>

            <div className="orgproc-grid-2col">
              {modulo.videos.map((video, idxVideo) => (
                <div className="orgproc-card" key={video.nombre}>
                  <div className="orgproc-card-accent"></div>
                  <div className="orgproc-card-body">
                    <div className="orgproc-eyebrow">Video {idxModulo + 1}.{idxVideo + 1}</div>
                    {estaVisto(video.url) && <span className="orgproc-visto-badge">✓ Visto</span>}
                    <div className="orgproc-card-title">{video.nombre}</div>

                    <div className="orgproc-card-block">
                      <div className="orgproc-card-block-label">Contenido</div>
                      <p className="orgproc-card-desc">{video.contenido}</p>
                    </div>

                    <div className="orgproc-card-block">
                      <div className="orgproc-card-block-label">
                        {video.analogia ? "Analogía" : "Escenario"}
                      </div>
                      {video.analogia ? (
                        <p className="orgproc-card-desc">{video.analogia}</p>
                      ) : video.escenarioRealista ? (
                        <ul className="orgproc-card-list">
                          {video.escenarioRealista.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      ) : (
                        <p className="orgproc-card-desc">—</p>
                      )}
                    </div>

                    <div className="orgproc-card-block">
                      <div className="orgproc-card-block-label">Función Principal</div>
                      <p className="orgproc-card-desc">{video.funcionPrincipal || "—"}</p>
                    </div>

                    <div className="orgproc-card-actions">
                      <button
                        type="button"
                        className="orgproc-card-btn"
                        onClick={() => handleShow(video)}
                      >
                        {estaVisto(video.url) ? "Volver a ver →" : "Reproducir Video →"}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </Container>
  
      <VideoModal show={show} video={videoActivo} onHide={handleClose} onPlay={marcarVisto} />
    </>
  );
}

export default IA;
